import { ViewProps } from './video.constants';
import { useContainerDimensions } from '../shared/component-height/component-dimensions.hooks';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ComponentStartCover } from '../shared/component-parts';
import { getPrintImage } from '../shared/logic/get-print-image';

const VideoStaticPreview = ({
  type,
  properties,
  stimulusResourceProperties,
}: ViewProps) => {
  const { style, setContainerElement } = useContainerDimensions({
    aspectRatio: 16 / 9,
  });

  return stimulusResourceProperties ? (
    <ComponentAspectRatio dimensions={properties.dimensionData}>
      <ComponentAbsoluteWrapper ref={setContainerElement}>
        <ComponentStartCover
          type={type}
          buttonLabel="Play"
          resourceName={stimulusResourceProperties?.resourceName || ''}
          backgroundImage={
            getPrintImage(
              stimulusResourceProperties?.xlCoverImageUrls || null
            ) || stimulusResourceProperties?.coverImage?.original
          }
          style={style}
          data-selector="btn-play"
        />
      </ComponentAbsoluteWrapper>
    </ComponentAspectRatio>
  ) : null;
};

export default VideoStaticPreview;
